import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, InputNumber } from 'antd';
import { Product } from '../../../services/product/product.service';

interface UpdatePriceModalProps {
  visible: boolean;
  onClose: () => void;
  onUpdate: (pricePerUserPerMonth: number) => Promise<void> | null;
  product: Product | null;
  loading: boolean;
}

const UpdatePriceModal: React.FC<UpdatePriceModalProps> = ({
  visible,
  onClose,
  onUpdate,
  product,
  loading
}) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (visible && product) {
      form.setFieldsValue({
        pricePerUserPerMonth: product.pricePerUserPerMonth
      });
    }
  }, [visible, product, form]);

  const handleSubmit = async (values: { pricePerUserPerMonth: number }) => {
    if (!product) return;
    
    setSubmitting(true);
    try {
      await onUpdate(values.pricePerUserPerMonth);
      form.resetFields();
      onClose();
    } catch (error) {
      // Error handling is done in the hook
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const getDurationText = (durationMonths: number) => {
    return `${durationMonths} Aylık`;
  };

  return (
    <Modal
      title={`${product ? getDurationText(product.durationMonths) : ''} Paket Fiyatını Güncelle`}
      open={visible}
      onCancel={handleClose}
      footer={null}
      width={500}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="mt-4"
      >
        <div className="mb-4">
          <p className="text-gray-600">
            <strong>Mevcut Paket:</strong> {product?.name}
          </p>
          <p className="text-gray-600">
            <strong>Mevcut Fiyat:</strong> ₺{product?.pricePerUserPerMonth}/kullanıcı/ay
          </p>
          <p className="text-sm text-amber-600 mt-2">
            * Fiyat güncellendiğinde eski kayıt deaktif edilir ve yeni kayıt oluşturulur.
          </p>
        </div>

        <Form.Item
          label="Yeni Kullanıcı Başına Aylık Fiyat"
          name="pricePerUserPerMonth"
          rules={[
            { required: true, message: 'Fiyat alanı zorunludur' },
            { type: 'number', min: 0.01, message: 'Fiyat 0\'dan büyük olmalıdır' }
          ]}
        >
          <InputNumber
            style={{ width: '100%' }}
            placeholder="Yeni fiyatı giriniz"
            precision={2}
            min={0.01}
            addonBefore="₺"
            addonAfter="/kullanıcı/ay"
            size="large"
          />
        </Form.Item>

        <div className="flex justify-end gap-2 mt-6">
          <Button onClick={handleClose} size="large">
            İptal
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={submitting || loading}
            size="large"
          >
            Fiyatı Güncelle
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default UpdatePriceModal; 